import React from 'react';
import styles from './Intuitive2.module.css';

import image1 from '../../../assets/intuitive2-asset-1.png';

const Intuitive2 = () => {
  return (
    <section className={styles.intuitive2Section}>
     <div>
      <p className={styles.topText}>We know that sometimes it's hard to find the right words to say,<br/> especially when first approaching someone.<br/><br/>We use AI to give you personalized ice breaker suggestions based on your shared interests and preferences.<br/>You just set the tone. </p>
      <h1 className={styles.orangeTitle}>AI generated ice breakers</h1>
      <img src={image1} alt="Image Lower Left" className={styles.assetLowerLeft}/>
    </div>
    </section>
  );
};

export default Intuitive2;
